export default {
    //漏洞分类
    bugType: {
        0: 'SQL注入',
        1: '反射型XSS',
        2: '存储型XSS',
        3: '代码执行',
        4: '信息泄露',
        5: 'CSRF',
        6: '任意文件上传',
        7: '远程命令执行',
        8: '逻辑缺陷',
    },
    //文章分类
    articleType: {
        0: '官方公告',
        1: '功能介绍',
        2: '安全预警',
        3: '修复教程',
        4: '案列分析',
        5: '支付相关',
    },
    //产品分类
    productType: {
        0: "现价",
        1: "数码周边",
        2: "生活周边",
        3: "专业数据",
        4: "厂商周边",
    },
    //ssl订单状态
    sslOrderType: {
        0: "待支付",
        1: "待签发",
    },
    //ssl应用场景
    sslAppType: {
        0: "小程序",
        1: "个人微企",
        2: "传统行业",
        3: "金融机构",
        4: "公共部门",
    },
    //ssl域名类型
    sslDomainTyle: {
        0: "单域名",
        1: "多域名",
        2: "泛域名",
    },
    //国家地区
    countryTyle: {
        CN: "中国",
        TW: "中国·台湾",
        SG: "新加坡",
        JP: "日本",
        FR: "法国",
        MO: "中国·澳门",
        USA: "美国",
        GBR: "英国",
        NL: "荷兰",
        PH: "菲律宾",
        KR: "韩国",
        HK: "中国·香港",
        MY: "马来西亚",
        CA: "加拿大",
        AU: "澳大利亚",
    },
    //加密算法
    encryptionAlgorithmType: {
        0: 'RSA',
        1: 'ECDSA',
    },
    //RSA加密强度
    RSAencryptionIntensityType: {
        0: '2048',
        1: '4096'
    },
    //ECDSA加密强度
    ECDSAencryptionIntensityType: {
        0: 'prime256v1'
    },
    //DV域名验证方式
    DVdomainVerificationType: {
        0: 'DNS',
        1: 'FILE',
        2: '自动DNS'
    },
    //EV、OV域名验证方式
    EVOVdomainVerificationType: {
        0: 'DNS',
        1: 'FILE',
        2: 'EMAIL',
        3: '自动DNS'
    },
    //CSR提交方式
    genCsrType: {
        online: "在线生成",
        parse: "粘贴CSR"
    },
    //资产管理列表标示
    assetsType: {
        0: '待验证',
        1: '已验证',
        2: '已失效',
        3: '已过期',
        4: '验证中',
    },
    //白帽提交漏洞等级
    whinfoBugLevelType: {
        0: "低",
        1: "中",
        2: "高",
        3: "严重",
    },
    //漏洞风险等级
    riskLevelTyle: {
        0: "低",
        1: "中",
        2: "高",
    },
    //资产漏洞等级
    assetsLeakType: {
        1: '低危',
        2: '中危',
        3: '高危'
    },
    //支付类型
    payType: {
        0: "支付宝",
        // 1:"微信"
    },
    //钱包交易类型
    walletType: {
        0: {
            flag: "+",
            val: "充值"
        },
        1: {
            flag: "-",
            val: "提现"
        },
        2: {
            flag: "-",
            val: "交易"
        },
        3: {
            flag: "+",
            val: "退款"
        },
    },
    //交易类型
    transactionType: {
        0: '新购',
        1: '续费'
    },
    //订单类型 or 优惠券类型
    orderType: {
        0: 'ssl证书',
        1: '企业资产',
        3: 'src开通',
        4: '威胁情报',
        5: '网址安全',
        6: 'API接口',
    },
    //发票类型
    invoiceType: {
        0: "企业增值税普通发票",
        1: "企业增值税专用发票",
    },
    //发票状态
    invoiceStateType: {
        0: '未受理',
        1: '已受理',
        2: '已寄出',
        3: '驳回'
    },
    //安全服务类型
    security: {
        0: '安全测试',
        1: '代码审计',
        2: '风险评估',
        3: '应急响应',
        4: '安全加固',
        5: '安全培训',
        6: '其他',
    },
    //费用中心交易状态
    costOrderType: {
        0: '待支付',
        1: '待支付',//原来的支付中
        2: '已支付'
    },
    //认证类型
    authType: {
        0: '个人认证',
        1: '企业认证',
    },
    //预警接收方式
    receivingMethod: {
        0: '手机',
        1: '邮件',
        // 2:'微信',
    },
    //预警分类
    earlywarningType: {
        0: "安全预警",
        1: "安全情报",
    },
    //资产风险概况登录
    assetsLevelTyle: {
        0: '业务',
        1: '漏洞'
    },
    //安服创建项目类型
    projectTyle: {
        0: '标准',
        1: '众测',
        2: '私密',
        3: '公益'
    },
    //安服创建项目状态
    projectState: {
        0: '待开启',
        1: '进行中',
        2: '已暂停',
        3: '已结束'
    },
    webAuthName: {
        0: "--",
        1: "HTTPS安全评估",
        2: "--",
        3: "--",
        4: "--",
        5: "--",
    },
    akOptions: [{
        value: "0",
        label: "阿里云",
    },
    {
        value: "1",
        label: "腾讯云",
    },
    {
        value: "2",
        label: "华为云",
    },
    {
        value: "3",
        label: "火山云",
    },]
}



// WEBPACK FOOTER //
// ./src/assets/js/apiType.js